<template>
    <div class="tw:w-full tw:md:w-auto" :class="props.customClass" :data-cy="props.dataCy">
        <div class="tw:relative">
            <select
                :value="props.value"
                :disabled="props.disabled || props.loading"
                class="tw:w-full tw:md:w-auto tw:border tw:border-gray-300 tw:rounded-lg tw:px-4 tw:py-2 tw:bg-white tw:appearance-none tw:pr-10"
                :class="{ 'tw:pr-10': props.loading || true }"
                @change="onChange"
            >
                <option v-if="props.placeholder" value="">
                    {{ props.placeholder }}
                </option>

                <option
                    v-for="option in props.options"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.label }}
                </option>
            </select>
            <div class="tw:absolute tw:right-3 tw:top-1/2 tw:-translate-y-1/2 tw:pointer-events-none">
                <svg v-if="props.loading" class="tw:animate-spin tw:h-4 tw:w-4 tw:text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="tw:opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                    <path class="tw:opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                </svg>
                <svg v-else class="tw:h-4 tw:w-4 tw:text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        value: {
            default: ''
        },
        options: {
            type: Array,
            required: true
        },
        placeholder: String,
        disabled: Boolean,
        loading: Boolean,
        customClass: String,
        dataCy: String
    })

    const emit = defineEmits(['input', 'change'])

    function onChange(event) {
        const value = event.target.value
        emit('input', value)
        emit('change', value)
    }
</script>